import React, { useContext, useEffect } from "react";
import {
  CustomButton2,
  CustomInput,
  CustomLeaflet,
  CustomView,
} from "../../../../../../../components";
import {
  ICityItem,
  ILocation,
  IProvinceItem,
} from "../../../../../../../types/common.interface";
import { IUpdateStudent } from "../../../../../../../types/student.interface";
import CustomDropDownSearch from "../../../../../../../components/CustomDropDownSearch";
import { useQuery } from "react-query";
import values from "../../../../../../../values";
import api from "../../../../../../../api";
import Context from "../../../../../../../context";
import utils from "../../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../../values/constants";

type Props = {
  defaultValue: IUpdateStudent;
  onSubmit: (formData: IUpdateStudent) => void;
  onBack: (formData: IUpdateStudent) => void;
};

const StudentLocation = (props: Props) => {
  // ** ===========================================================================================================
  // **                                            Values Validation
  // ** -----------------------------------------------------------------------------------------------------------

  const { userInfo } = useContext(Context.UserScreen);
  const { selectedUser } = React.useContext(Context.ServiceScreen);
  const [selectedProvince, setSelectedProvince] = React.useState<any>();
  const [selectedCity, setSelectedCity] = React.useState<any>();
  const [address, setAddress] = React.useState<string>(
    props?.defaultValue?.address ? props.defaultValue.address : ""
  );
  const [nationality, setNationality] = React.useState<string>(
    props?.defaultValue?.nationality ? props.defaultValue.nationality : "ایران"
  );
  const [location, setLocation] = React.useState<ILocation>({
    lng: props?.defaultValue?.lng ? props?.defaultValue?.lng : "",
    lat: props?.defaultValue?.lat ? props?.defaultValue?.lat : "",
  });
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    city: "",
  });

  // !! ===========================================================================================================
  // !!                                              REST API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince, selectedUser],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince
          ? selectedProvince?.Code
          : getAllProvince?.data?.result?.find(
              (item: IProvinceItem) =>
                item?._id === selectedUser?.student?.province
            ).Code,
      })
  );

  // ** ===========================================================================================================
  // **                                            Local Functions
  // ** -----------------------------------------------------------------------------------------------------------
  function onSubmitBack() {
    props.onBack({
      ...props.defaultValue,
      province: selectedProvince,
      city: selectedCity,
      lat: location.lat,
      lng: location.lng,
      nationality,
      address,
    });
  }

  function onSubmitForward() {
    let dropDownErrorsList = {
      province: "",
      city: "",
    };
    if (!selectedProvince) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        province: "انتخاب استان اجباری است",
      };
    }
    if (!selectedCity) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        city: "انتخاب شهر اجباری است",
      };
    }

    setDropDownErrors(dropDownErrorsList);

    if (selectedProvince && selectedCity) {
      props.onSubmit({
        ...props.defaultValue,
        lat: location.lat,
        lng: location.lng,
        nationality,
        province: selectedProvince,
        city: selectedCity,
      });
    }
  }

  useEffect(() => {
    setSelectedProvince(selectedUser?.province);
    setSelectedCity(selectedUser?.city);
  }, [selectedUser]);

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const provinceFiltered = getAllProvince?.data?.result?.filter((item: any) =>
    userInfo?.companyInformation?.province?.includes(item?._id)
  );
  const cityFiltered = getAllCity?.data?.result?.filter((item: any) =>
    userInfo?.companyInformation?.city?.includes(item?._id)
  );

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  // console.log(selectedUser.province);
  // console.log(selectedUser.city);
  return (
    <CustomView.Container className="create-form-content">
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum">
          <label className="form-label">انتخاب استان</label>
          <CustomDropDownSearch
            isSearch
            items={
              userType === "COMPANY"
                ? provinceFiltered
                : getAllProvince?.data?.result
            }
            itemName="Name"
            onSelectItem={(event: any) => {
              setSelectedProvince(event);
              setDropDownErrors({ ...dropDownErrors, province: "" });
            }}
            placeHolder="انتخاب استان"
            defaultItem={selectedProvince}
            isLoading={getAllProvince.isLoading}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum">
          <label className="form-label">انتخاب شهر</label>
          <CustomDropDownSearch
            isSearch
            items={
              userType === "COMPANY" ? cityFiltered : getAllCity?.data?.result
            }
            itemName="Name"
            onSelectItem={(event: any) => {
              setSelectedCity(event);
              setDropDownErrors({ ...dropDownErrors, city: "" });
            }}
            placeHolder="انتخاب شهر"
            defaultItem={selectedCity}
            isLoading={getAllCity.isLoading}
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum">
          <CustomInput
            label="ملیت"
            value={nationality}
            placeHolder="ایران"
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setNationality(event.target.value)
            }
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum">
          <CustomInput
            label="آدرس"
            value={address}
            placeHolder="آدرس"
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setAddress(event.target.value)
            }
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum" medium={12}>
          <CustomLeaflet
            defaultLat={
              location.lat ? location.lat : selectedUser?.student?.lat
            }
            defaultLng={
              location.lng ? location.lng : selectedUser?.student?.lng
            }
            onChangeLatAndLng={(lat: any, lng: any) =>
              setLocation({ lat, lng })
            }
          />
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitBack} title="قبلی" type="danger" />
        </CustomView.Column>
        <CustomView.Column className="form-colum" medium={6}>
          <CustomButton2 onClick={onSubmitForward} title="بعدی" />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default StudentLocation;
